<form [formGroup]="civilIdInfoForm" id="wizardForm2" novalidate="novalidate" data-wizard-form="2"
    class="contact-info-form">
    <div class="container">
        <div class="row">
            <div class="col-12" [ngClass]="parentComponent === componentName.SIGN_UP ? 'p-0' : 'col-sm-6 col-xl-4'">
                <div class="form-floating mt-4">
                    <input class="form-control px-4" id="civilId" type="text"
                        placeholder="{{'CREATE_VISA.CIVIL_ID_INFO.CIVIL_ID_NO' | translate}}" autocomplete="off"
                        value="{{ civilIdInfoForm.get('civilId')?.value}}" disabled (keydown)="InputChanges($event)" />
                    <label>{{'CREATE_VISA.CIVIL_ID_INFO.CIVIL_ID_NO' | translate}}</label>
                    <app-validation-message [formSubmission]="isSubmitted"
                        [control]="civilIdInfoForm.get('civilId')"></app-validation-message>
                </div>
            </div>
            @if(translate.currentLang === 'en'){
            <div class="col-12" [ngClass]="parentComponent === componentName.SIGN_UP ? 'p-0' : 'col-sm-6 col-xl-4'">
                <div class="form-floating mt-4">
                    <input class="form-control px-4" id="fullNameEn" type="text"
                        placeholder="{{'CREATE_VISA.CIVIL_ID_INFO.FULL_NAME_EN' | translate}}" autocomplete="off"
                        value="{{ civilIdInfoForm.get('fullnameEn')?.value}}" disabled
                        (keydown)="InputChanges($event)" />
                    <label>{{'CREATE_VISA.CIVIL_ID_INFO.FULL_NAME_EN' | translate}}</label>
                    <app-validation-message [formSubmission]="isSubmitted"
                        [control]="civilIdInfoForm.get('fullnameEn')"></app-validation-message>
                </div>
            </div>
            }@else{
            <div class="col-12" [ngClass]="parentComponent === componentName.SIGN_UP ? 'p-0' : 'col-sm-6 col-xl-4'">
                <div class="form-floating mt-4">
                    <input class="form-control px-4" id="fullName" type="text"
                        placeholder="{{'CREATE_VISA.CIVIL_ID_INFO.FULL_NAME_AR' | translate}}" autocomplete="off"
                        value="{{ civilIdInfoForm.get('fullnameAr')?.value}}" disabled
                        (keydown)="InputChanges($event)" />
                    <label>{{'CREATE_VISA.CIVIL_ID_INFO.FULL_NAME_AR' | translate}}</label>
                    <app-validation-message [formSubmission]="isSubmitted"
                        [control]="civilIdInfoForm.get('fullnameAr')"></app-validation-message>
                </div>
            </div>
            }
            <div class="col-12" [ngClass]="parentComponent === componentName.SIGN_UP ? 'p-0' : 'col-sm-6 col-xl-4'">
                <div class="form-floating mt-4">
                    <input class="form-control px-4" id="gender" type="text"
                        placeholder="{{'CREATE_VISA.CIVIL_ID_INFO.GENDER' | translate}}" autocomplete="off" value="{{ (civilIdInfoForm.get('gender')?.value === 'Male' ? 
                    'GENDER.MALE' : this.civilIdInfoForm.get('gender')?.value === 'Female' ?
                     'GENDER.FEMALE' : 'GENDER.OTHERS') | translate}}" disabled (keydown)="InputChanges($event)" />
                    <label>{{'CREATE_VISA.CIVIL_ID_INFO.GENDER' | translate}}</label>
                    <app-validation-message [formSubmission]="isSubmitted"
                        [control]="civilIdInfoForm.get('gender')"></app-validation-message>
                </div>
            </div>
            <div class="col-12" [ngClass]="parentComponent === componentName.SIGN_UP ? 'p-0' : 'col-sm-6 col-xl-4'">
                <div class="form-floating mt-4">
                    <input class="form-control px-4" id="dateOfBirth" type="text"
                        placeholder="{{'CREATE_VISA.CIVIL_ID_INFO.DATE_OF_BIRTH' | translate}}" autocomplete="off"
                        value="{{ (translate.currentLang === 'ar' ?  civilIdInfoForm.get('dateOfBirth')?.value : (civilIdInfoForm.get('dateOfBirth')?.value | date: 'dd-MM-yyyy'))}}"
                        disabled (keydown)="InputChanges($event)" />
                    <label>{{'CREATE_VISA.CIVIL_ID_INFO.DATE_OF_BIRTH' | translate}}</label>
                    <app-validation-message [formSubmission]="isSubmitted"
                        [control]="civilIdInfoForm.get('dateOfBirth')"></app-validation-message>
                </div>
            </div>
            @if(translate.currentLang === 'en'){
            <div class="col-12" [ngClass]="parentComponent === componentName.SIGN_UP ? 'p-0' : 'col-sm-6 col-xl-4'">
                <div class="form-floating mt-4">
                    <input class="form-control px-4" id="nationalityEn" type="text"
                        placeholder="{{'CREATE_VISA.CIVIL_ID_INFO.NATIONALITY_EN' | translate}}" autocomplete="off"
                        value="{{ civilIdInfoForm.get('passportNationality')?.value}}" disabled
                        (keydown)="InputChanges($event)" />
                    <label>{{'CREATE_VISA.CIVIL_ID_INFO.NATIONALITY_EN' | translate}}</label>
                    <app-validation-message [formSubmission]="isSubmitted"
                        [control]="civilIdInfoForm.get('passportNationality')"></app-validation-message>
                </div>
            </div>
            }@else{
            <div class="col-12" [ngClass]="parentComponent === componentName.SIGN_UP ? 'p-0' : 'col-sm-6 col-xl-4'">
                <div class="form-floating mt-4">
                    <input class="form-control px-4" id="nationality" type="text"
                        placeholder="{{'CREATE_VISA.CIVIL_ID_INFO.NATIONALITY_AR' | translate}}" autocomplete="off"
                        value="{{ civilIdInfoForm.get('passportNationalityAr')?.value}}" disabled
                        (keydown)="InputChanges($event)" />
                    <label>{{'CREATE_VISA.CIVIL_ID_INFO.NATIONALITY_AR' | translate}}</label>
                    <app-validation-message [formSubmission]="isSubmitted"
                        [control]="civilIdInfoForm.get('passportNationalityAr')"></app-validation-message>
                </div>
            </div>
            }
            @if(parentComponent === componentName.SIGN_UP){
            <div class="form-floating mt-4 p-0 mandatory-select">
                <ng-select [notFoundText]="'HEADER.NO_ITEMS_FOUND' | translate" [searchable]="false"
                    [dropdownPosition]="'bottom'" [clearable]="false" formControlName="preferredLanguage"
                    [placeholder]="'PROFILE.PREFERRED_LANGUAGE' | translate">
                    @for (language of preferredLanguageList; track $index) {
                    <ng-option [value]="language.value">
                        {{language.name | translate}}
                    </ng-option>
                    }
                </ng-select>
                <app-validation-message [control]="civilIdInfoForm.get('preferredLanguage')"
                    [formSubmission]="isSubmitted"></app-validation-message>
            </div>
            }
            <div class="col-12" [ngClass]="parentComponent === componentName.SIGN_UP ? 'p-0' : 'col-sm-6 col-xl-4'">
                <div class="d-flex align-items-start gap-1">
                    <div class="country-select mt-4">
                        <lib-country-list #countryDropdown [selectedCountryConfig]="selectedCountryConfig"
                            [blockedCountryCodes]="blockedCountriesList" [countryListConfig]="countryListConfig"
                            [selectedCountryCode]="defaultCountryCode"
                            (onCountryChange)="onCountryCodeChange($event)"></lib-country-list>
                    </div>
                    <div class="flex-grow-1 form-floating mt-4">
                        <input class="form-control px-4" id="phoneNumberValue" type="number"
                            placeholder="{{'CREATE_VISA.CONTACT_INFO.MOBILE_NO' | translate}}"
                            formControlName="phoneNumberValue" [max]="mobileMaxLimit" autocomplete="off"
                            appNumberOnly />
                        <label class="mandatory">{{'CREATE_VISA.CONTACT_INFO.MOBILE_NO' | translate}}</label>
                        <app-validation-message [formSubmission]="isSubmitted"
                            [control]="civilIdInfoForm.get('phoneNumberValue')"></app-validation-message>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>